<div class="tree-block-content">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="partitions-tree">
        <!-- Node without children (leaf) -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle
            [ngClass]="{invisible: !isVisible(node)}">
            <li class="mat-tree-node">
                <button mat-icon-button disabled></button>
                <app-partitions-tree-node *ngIf="!isMultiple" [node]="node"
                    [selectedNodeCode]="selectedNode.partitionDetails.code" (nodeSelected)="onSelectPart(node)">
                </app-partitions-tree-node>
                <mat-checkbox *ngIf="isMultiple" class="checklist-leaf-node"
                    [checked]="checklistSelection.isSelected(node)" (change)="onToggleSelection(node)">
                    {{node.partitionDetails.text?.shortLabel}}</mat-checkbox>
            </li>
        </mat-tree-node>

        <!-- Node with children (branch) -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild"
            [ngClass]="{invisible: !isVisible(node)}">
            <li>
                <div class="mat-tree-node">
                    <button mat-icon-button matTreeNodeToggle
                        [attr.aria-label]="'toggle ' + node.partitionDetails.text?.shortLabel">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    <app-partitions-tree-node *ngIf="!isMultiple" [node]="node"
                        [selectedNodeCode]="selectedNode.partitionDetails.code" (nodeSelected)="onSelectPart(node)">
                    </app-partitions-tree-node>
                    <mat-checkbox *ngIf="isMultiple && !isFirstLevelNode(node)"
                        [checked]="checklistSelection.isSelected(node)" (change)="onToggleSelection(node)">
                        {{node.partitionDetails.text?.shortLabel}}</mat-checkbox>
                    <span *ngIf="isMultiple && isFirstLevelNode(node)">{{node.partitionDetails.text?.shortLabel}}</span>
                </div>
                <ul [class.partitions-tree-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                </ul>
            </li>
        </mat-nested-tree-node>
    </mat-tree>
</div>
